// @flow

const $ = require('jquery');

require('./webActions/hsExpand');
require('./web/jquery.gridLayout');
require('./web/jquery.zusnaCalendar');
require('./web/jquery.zusnaPagination');
require('./web/jquery.webslider');

const $grid = $('.gridLayout');
const $feedArticles = $('#block-articles.replace-pagination');
const $calendar = $('#calendarContainer');

/* scrollable calendar */
try {
	$calendar.zusnaCalendar();
	$(window)
			.resize(() => {
				$calendar.zusnaCalendar('resize');
			});
} catch (e) {
	if (window.console) console.trace(e);
}

/* pinterest-like-grid (galleries + news) */
try {
// pod 720px sirky nema pouziti pluginu smysl, itemy se seskladaji do jedineho sloupce
	if ($grid.length > 0 && $(document)
			.outerWidth(true) > 720) {
		$(window)
				.load(() => { // cekat na vsechny obrazky
					$grid.gridLayout();
				});
		$(window)
				.resize(() => {
					$grid.gridLayout();
				});
	}
} catch (e) {
	if (window.console) console.trace(e);
}

try {
	$feedArticles.zusnaPagination();
} catch (e) {
	if (window.console) console.trace(e);
}

// nakonec rozbalit kalendar
// je nutny click(), aplikuji se dalsi navazane akce, nestaci jen rozbalit .collapse
/*
$('a[href="#calendarContainer"]').click(); // otocena logika kvuli noscript verzi
/ */
$('a[href="#calendarContainer"]')
		.removeClass('collapsed');
/* ///

/*
* !!!NECHAT NA KONCI web.js!!!
* V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
* že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
* Inline JavaScript musí být vnořen do následujícího kusu kódu
*
* $(function(){
*     //inline JavaScript
* });
*
* který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
* předpokládá se tedy, že na webu bude použito jQuery
*
* viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
* */
$.each(q, (index, f) => {
	$(f);
});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js